export const SupportActionTypes = {
    SET_FAQS: 'admin/SET_FAQS',
    SET_LOADING_FAQS: 'admin/SET_LOADING_FAQS',
    SET_FAQ: 'admin/SET_FAQ',
    SET_LOADING_FAQ: 'admin/SET_LOADING_FAQ',
    SET_FAQ_NOT_FOUND: 'admin/SET_FAQ_NOT_FOUND',
}